import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DEFAULT_BRANDS } from '@cortex/mall-scoring';
import { Card } from '../../components/ui/Card';

/**
 * @graph-node {Page}
 * @graph-stack mall
 * @graph-domain Operations
 * @graph-business ブランドマスタ一覧ページ。本番DB実績データ（DEFAULT_BRANDS）をテーブル表示（読み取り専用）
 * @graph-connects none
 */
export const Route = createFileRoute('/master/brands')({
  component: BrandsPage,
});

/** @graph-connects none */
function BrandsPage() {
  const { t } = useTranslation();
  const entries = Object.entries(DEFAULT_BRANDS);

  return (
    <Card variant="glass" className="animate-fade-in">
      <div className="mb-4 p-3 rounded-lg bg-[var(--color-info-muted)] border border-[var(--color-info)]/20">
        <span className="text-sm text-[var(--color-text-secondary)]">
          {t('master.productionDataNote')}
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[var(--color-text-muted)] text-xs border-b border-[var(--color-border)]">
              <th className="text-left py-3 pr-4">{t('master.brandKey')}</th>
              <th className="text-left py-3 px-4">{t('master.brandLabel')}</th>
              <th className="text-right py-3 pl-4">{t('master.fallbackRate')}</th>
            </tr>
          </thead>
          <tbody>
            {entries.map(([key, brand]) => (
              <tr key={key} className="border-b border-[var(--color-border)] last:border-b-0">
                <td className="py-2.5 pr-4 font-mono text-[var(--color-text-primary)]">{key}</td>
                <td className="py-2.5 px-4 text-[var(--color-text-secondary)]">{brand.label}</td>
                <td className="py-2.5 pl-4 text-right font-mono text-[var(--color-text-secondary)]">
                  {brand.fallbackRate.toFixed(1)}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
